module.exports = __webpack_public_path__ + "9cc2802f3f29eaf534f0cfee9214d222.svg";